import React from 'react'
import Modal from '@material-ui/core/Modal'
import { Box } from '@material-ui/core'

function ModalWindow({ open, onClose, children }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(86, 89, 112, 0.2)',
        },
      }}>
      <Box className="modal-box">{children}</Box>
    </Modal>
  )
}

export default ModalWindow
